import * as React from 'react';
import { Dispatch } from 'react-redux';

import { StyledPreviewPage, PreviewPageImage } from './styles';
import Utils from '../../../utils';
import { createNotification } from '../../../containers/NotificationBar/actions';
import { StoreState } from '../../../reducers';

interface PreviewPageProps {
	src: string;
	zoom: number;
	dispatch: Dispatch<StoreState>;
}

const PreviewPage = ({ src, zoom, dispatch }: PreviewPageProps) => {
	const pageContainer = React.useRef<HTMLDivElement>(null);
	const [isLoaded, setIsLoaded] = React.useState(false);
	const [isError, setError] = React.useState(false);

	const handleError = async () => {
		setError(true);

		try {
			// call to this url will initiate a re-login in case session was expired
			const { status } = await Utils.promiseXHR('GET', src);
			if (status === 200) {
				setError(false);
			} else {
				dispatch(createNotification('error.fetch_editor_data_error'));
			}
		} catch (error) {
			dispatch(createNotification('error.fetch_editor_data_error'));
		}
	};

	React.useEffect(() => {
		setIsLoaded(false);
	}, [src]);

	React.useEffect(() => {
		if (isLoaded && pageContainer.current) {
			pageContainer.current.scrollIntoView();
		}
	}, [isLoaded]);

	if (isError) {
		return null;
	}

	return (
		<StyledPreviewPage ref={pageContainer}>
			<PreviewPageImage
				src={src}
				zoom={zoom}
				onLoad={() => setIsLoaded(true)}
				onError={handleError}
			/>
		</StyledPreviewPage>
	);
};

export default PreviewPage;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/PreviewPage/index.tsx